import { cn } from "@/lib/utils";

type Props = {
    name: string;
    avatarUrl: string | null;
    className?: string;
};

function initials(name: string): string {
    return name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase() ?? "")
        .join("");
}

export function AgentAvatar({ name, avatarUrl, className }: Props) {
    if (avatarUrl) {
        return (
            <img
                src={avatarUrl}
                alt=""
                className={cn(
                    "size-6 shrink-0 rounded-full bg-zinc-200 object-cover",
                    className,
                )}
            />
        );
    }

    return (
        <span
            aria-hidden
            className={cn(
                "flex size-6 shrink-0 items-center justify-center rounded-full bg-zinc-100 font-medium text-[10px] text-zinc-600",
                className,
            )}
        >
            {initials(name) || "?"}
        </span>
    );
}
